import Request from '@/utils/request'

// 啤酒兑换道具列表
export function apiBeerExchangeList () {
  return Request({
    url: '/api/v2/app/beer/exchange',
    method: 'get'
  })
}

// 啤酒兑换记录
// offset 第几页 limit 每页个数
export function apiBeerExchangeHistory (params) {
  return Request({
    url: '/api/v2/app/beer/exchange/history',
    method: 'get',
    params
  })
}

// 啤酒兑换道具
export function apiBeerExchange (propType, propId, exchangeNum) {
  return Request({
    url: '/api/v2/app/beer/exchange',
    method: 'post',
    data: {
      propType,
      propId,
      exchangeNum
    }
  })
}